export default __webpack_public_path__ + "static/media/snow.0f5138c4.svg";